// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__vfgEc","containerPadding":"Breadcrumbs_containerPadding___B9b6","list":"Breadcrumbs_list__yKeNX","listItem":"Breadcrumbs_listItem__jq0Zq"};